import React from 'react'
import type { ReactNode } from 'react'
import { Loading } from 'flipper-ui'
import { useDesignVersion } from '@core/layout/design-version/useDesignVersion'
import LayoutV1 from '@core/layout/v1/LayoutV1'
import LayoutV2 from '@core/layout/v2/LayoutV2'

interface IProps {
    children: ReactNode
}

export const AppContent = (props: IProps) => {
    const { isV2, initializing } = useDesignVersion()

    if (initializing) {
        return <Loading />
    }

    return isV2 ? (
        <LayoutV2>{props.children}</LayoutV2>
    ) : (
        <LayoutV1>{props.children}</LayoutV1>
    )
}
